"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../");
var VeriLiteInformationEvent = /** @class */ (function () {
    function VeriLiteInformationEvent(content, title, actions) {
        if (title === void 0) { title = ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.resources) === null || _b === void 0 ? void 0 : _b.Information) || "Information"; }
        if (actions === void 0) { actions = VeriLiteInformationEvent.DefaultActions(window.resources); }
        var _a, _b;
        this.content = content;
        this.title = title;
        this.actions = actions;
        this.color = "dark";
        this.backdrop = true;
        this.closeOption = true;
        this.allowKeyboard = true;
    }
    VeriLiteInformationEvent.DefaultActions = function (resources) { return [
        new __1.VeriLiteEventAction(resources.Ok || "Ok", "primary", function (currentEvent, closeModalCallback) {
            closeModalCallback();
        })
    ]; };
    return VeriLiteInformationEvent;
}());
exports.VeriLiteInformationEvent = VeriLiteInformationEvent;
//# sourceMappingURL=InformationEvents.js.map